// router/authGuard.js
import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getCurrentUser } from '@aws-amplify/auth';

const AuthGuard = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    useEffect(() => {
        const checkUser = async () => {
            try {
                await getCurrentUser();
                setIsAuthenticated(true);
            } catch {
                setIsAuthenticated(false);
            }
        };
        checkUser();
    }, []);

    if (isAuthenticated === null) return null;

    if (!isAuthenticated) {
        return <Navigate to="/loginRedirect" replace />;
    }

    return <Outlet />;
};

export default AuthGuard;